module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/storage_unit-07fa8594575bd58b02126f0ebc7f4a8b.png";